export default __webpack_public_path__ + "static/media/escuela_verde_inicial.3dc44d8c.jpg";